import React from 'react';
import PropTypes from 'prop-types';

import { Card, Row } from 'react-bootstrap';

import { ATLAS_TEMPLATES } from '../../atoms/AtlasAtoms/atlas-elements';

const TelemetrySelector = props => {
  const { element, selectServer } = props;
  const { image } = ATLAS_TEMPLATES.properties.TEMPLATESCORECARDONECOMPONENT;
  const tamano = () => {
    const screenSize = window.innerWidth / window.screen.availWidth;
    if (screenSize < 0.3) {
      return '8rem';
    }
    return '10rem';
  };
  return (
    <Row style={{ margin: '10px' }}>
      <Card
        style={{
          borderRadius: '20%',
          cursor: 'pointer',
          overflow: 'hidden',
          height: tamano(),
          width: tamano(),
          margin: 0
        }}
        onClick={() => selectServer(element)}
      >
        <Card.Text style={{ margin: 0, fontSize: 16 }} align="center">
          {element}
        </Card.Text>
        <Card.Img variant="top" src={image} />
      </Card>
    </Row>
  );
};
TelemetrySelector.defaultProps = {
  element: ''
};

TelemetrySelector.propTypes = {
  element: PropTypes.string,
  selectServer: PropTypes.func.isRequired
};
export default TelemetrySelector;
